import * as React from "react";
const SvgFaqOutlined = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      d="M11.95 18q.525 0 .888-.363t.362-.887-.362-.888a1.2 1.2 0 0 0-.888-.362 1.2 1.2 0 0 0-.887.363q-.36.36-.363.887-.003.526.363.888t.887.362m-.9-3.85h1.85q0-.825.188-1.3t1.062-1.3a7.5 7.5 0 0 0 1.025-1.238q.375-.588.375-1.412 0-1.4-1.025-2.15T12.1 6q-1.424 0-2.312.75T8.55 8.55l1.65.65q.125-.45.563-.975T12.1 7.7q.8 0 1.2.438t.4.962q0 .5-.3.938t-.75.812q-1.1.975-1.35 1.475t-.25 1.825M12 22a9.7 9.7 0 0 1-3.9-.787 10.1 10.1 0 0 1-3.175-2.138q-1.35-1.35-2.137-3.175A9.75 9.75 0 0 1 2 12q0-2.076.788-3.9a10.2 10.2 0 0 1 2.137-3.175A10 10 0 0 1 8.1 2.788 9.8 9.8 0 0 1 12 2a9.7 9.7 0 0 1 3.9.788 10.1 10.1 0 0 1 3.175 2.137A10.1 10.1 0 0 1 21.213 8.1 9.7 9.7 0 0 1 22 12a9.8 9.8 0 0 1-.788 3.9 10 10 0 0 1-2.137 3.175q-1.352 1.346-3.175 2.138A9.6 9.6 0 0 1 12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
    />
  </svg>
);
export default SvgFaqOutlined;
